import posthog from 'posthog-js';

export function trackEvent(event: string, properties?: Record<string, unknown>): void {
  if (!posthog.__loaded) return;
  posthog.capture(event, properties);
}

export function identifyLead(properties: Record<string, unknown>): void {
  if (!posthog.__loaded) return;
  posthog.setPersonProperties(properties);
}
